import React, { useState } from 'react';
import '../../styles/FiltersBar.css';
import { icons } from '../../assets/icons';

export default function FiltersBar({
  // VIEW
  viewType,
  setViewType,
  setGridView,
  setWheelDisplayView,

  // SORT
  sortBy,
  setSortBy,
  handleSortTypeChange,

  // GENRES
  genres,
  genreTypes,
  handleGenreTypeChange,
  handleGenreTypeTagChange,
  genreDropdownOpen,
  toggleGenreDropdown,
  genreReset,
  genreDropdownRef,

  // SEEN
  options,
  seenToggle,
  setSeenToggle,
  handleSeenToggleChange,
  seenDropdownOpen,
  toggleSeenDropdown,
  seenDropdownRef,

  // VIEW CONDITION
  isWheelDisplayView,

  // LOGIN CONTROLS
  handleLogOut,
  addMovieButtonClicked,

  listPanelOpen,
  toggleListPanel,
}) {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  const closeMobileFilters = () => {
    setMobileFiltersOpen(false);
  };

  return (
    <div className="filters-container">
      {/* LEFT SIDE */}
      <div className="filters-left">
        {/* VIEW ICONS (always visible) */}
        <div id="imgs-buttons-filters">
          <button
            className={`list-panel-toggle ${listPanelOpen ? 'active' : ''}`}
            onClick={toggleListPanel}
            title="My Lists"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
              <rect y="3" width="18" height="2" rx="1" />
              <rect y="8" width="18" height="2" rx="1" />
              <rect y="13" width="18" height="2" rx="1" />
            </svg>
          </button>
          <div className="iconWrapper">
            <img
              className={`filter-img ${viewType === 'grid' ? 'selected' : ''}`}
              src={icons.gridIcon}
              alt="grid view"
              onClick={() => {
                setViewType('grid');
                setGridView?.();
              }}
            />
          </div>

          <div className="iconWrapper">
            <img
              className={`filter-img ${viewType === 'wheel' ? 'selected' : ''}`}
              src={icons.wheelIcon}
              alt="wheel selector"
              onClick={() => {
                setViewType('wheel');
                setWheelDisplayView?.();
              }}
            />
          </div>
        </div>

        {/* DESKTOP CONTROLS */}
        {!isWheelDisplayView && (
          <div className="filters-desktop">
            {/* SORT */}
            <select
              id="sortBySelect"
              className="form-select"
              value={sortBy}
              onChange={handleSortTypeChange}
            >
              <optgroup label="Sort By">
                <option value="alphabetical">Alphabetical</option>
                <option value="date">Date Added</option>
                <option value="rating">Your Rating</option>
              </optgroup>
            </select>

            {/* GENRE */}
            <div className="dropdown" ref={genreDropdownRef}>
              <button
                className="btn btn-secondary dropdown-toggle"
                onClick={toggleGenreDropdown}
              >
                Genre
              </button>

              <div
                className={`dropdown-menu${genreDropdownOpen ? ' show' : ''}`}
              >
                <button onClick={genreReset}>Reset</button>

                {genres.map((genre) => (
                  <div key={genre.value} className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={genre.value}
                      checked={genreTypes.includes(genre.value)}
                      onChange={handleGenreTypeChange}
                    />
                    <label className="form-check-label">{genre.label}</label>
                  </div>
                ))}
              </div>
            </div>

            {/* SEEN */}
            <div className="dropdown" ref={seenDropdownRef}>
              <button
                className="btn btn-secondary dropdown-toggle"
                onClick={toggleSeenDropdown}
              >
                Seen
              </button>

              <div
                className={`dropdown-menu${seenDropdownOpen ? ' show' : ''}`}
              >
                <button onClick={() => setSeenToggle(null)}>Reset</button>

                {options.map((option) => (
                  <div key={option.value} className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={option.value}
                      checked={seenToggle === option.value}
                      onChange={handleSeenToggleChange}
                    />
                    <label className="form-check-label">{option.label}</label>
                  </div>
                ))}
              </div>
            </div>

            {/* SELECTED GENRES */}
            <div className="selected-genres-display">
              {genreTypes.length > 0 &&
                genreTypes.map((genre, index) => (
                  <div className="genre-tags" key={index}>
                    <button
                      className="close-genre"
                      onClick={() => handleGenreTypeTagChange(genre)}
                    >
                      x
                    </button>
                    <p className="genre-tag-name">{genre}</p>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* MOBILE FILTER BUTTON */}
        {!isWheelDisplayView && (
          <div className="filters-mobile">
            <img
              src={icons.filterIcon}
              alt="filter panel"
              className="filter-toggle-btn"
              onClick={() => setMobileFiltersOpen((p) => !p)}
            />
          </div>
        )}
      </div>

      {/* RIGHT SIDE */}
      <div className="filters-right">
        <button
          className="btn btn-secondary dropdown-toggle"
          id="add-movie-button"
          onClick={addMovieButtonClicked}
        >
          Add Movie
        </button>

        <button
          className="btn btn-secondary dropdown-toggle"
          id="admin-logout"
          onClick={handleLogOut}
        >
          Log Out
        </button>
      </div>

      {/* MOBILE FILTER POPUP */}
      {mobileFiltersOpen && (
        <div className="filters-popup">
          {/* SORT */}
          <div className="filters-section">
            <button onClick={closeMobileFilters} className="filters-close-btn">
              ×
            </button>
            <div className="filter-section-title">Order</div>

            <label>
              <input
                type="checkbox"
                checked={sortBy === 'rank'}
                onChange={() => setSortBy('rank')}
              />
              Rank
            </label>

            <label>
              <input
                type="checkbox"
                checked={sortBy === 'alphabetical'}
                onChange={() => setSortBy('alphabetical')}
              />
              Alphabetical
            </label>
          </div>

          {/* SEEN */}
          <div className="filters-section">
            <div className="filter-section-title">Seen</div>
            {options.map((opt) => (
              <label key={opt.value}>
                <input
                  type="checkbox"
                  checked={seenToggle === opt.value}
                  onChange={handleSeenToggleChange}
                  value={opt.value}
                />
                {opt.label}
              </label>
            ))}
          </div>

          {/* GENRE */}
          <div className="filters-section">
            <div className="filter-section-title">Genres</div>
            <button className="filter-reset-btn" onClick={genreReset}>
              Reset
            </button>

            {genres.map((g) => (
              <label key={g.value}>
                <input
                  type="checkbox"
                  value={g.value}
                  checked={genreTypes.includes(g.value)}
                  onChange={handleGenreTypeChange}
                />
                {g.label}
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
